module.exports = __webpack_public_path__ + "img/center-focus.8e0b4750.svg";